const A = "/brand";

const testimonials = [
  {
    img: `${A}/testimonial-loriann-fox-200.jpg`,
    name: "Loriann Fox",
    role: "Chief Legal Officer",
    quote:
      "Working with Lara was refreshing and eye-opening. She helped me identify what wasn't working for me and find what does. It was powerful to have someone help me see my dreams clearly — and then actually live them.",
  },
  {
    img: `${A}/testimonial-denise-roistacher-200.jpg`,
    name: "Denise Roistacher, M.S., ACC",
    role: "Executive Coach",
    quote:
      "As an executive coach, I value depth over performance — and Lara delivers depth. Her work helps high-achieving women move from external success to true internal alignment in a way that creates sustainable change.",
  },
  {
    img: `${A}/testimonial-tedd-snyder-200.jpg`,
    name: "Tedd Snyder, MBA",
    role: "Lean Six Sigma Master Black Belt, MBA",
    quote:
      "My career has been spent helping people improve their processes at work. Over four years in Lara's Nightly Gratitude Room, I've watched her help people improve their life processes. She connects with many different personalities — even a strongly analytical thinker like me.",
  },
];

export function HomeTestimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative overflow-hidden"
      style={{ background: "linear-gradient(180deg, #FFFFFF 0%, #FEFEFE 30%, #F9F8F7 100%)" }}
    >
      <div
        aria-hidden
        className="absolute bottom-0 right-0 w-[600px] h-[600px] opacity-[0.015]"
        style={{ background: "radial-gradient(circle, #159E9A 0%, transparent 65%)" }}
      />
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-6 md:pt-8 pb-12 md:pb-14 relative z-[1]">
        <div className="max-w-3xl mb-10 reveal">
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.08] tracking-tight text-[#1C1917]">
            Alignment Changes Everything.
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-12">
          {testimonials.map((tt, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="reveal flex flex-col relative"
            >
              <div className="mb-6 relative aspect-[4/5] overflow-hidden">
                <img
                  src={tt.img}
                  alt={tt.name}
                  loading="lazy"
                  className="w-full h-full object-cover"
                />
                <div
                  className="absolute inset-x-0 bottom-0 h-24"
                  style={{ background: "linear-gradient(to top, rgba(249,248,247,0.2) 0%, transparent 100%)" }}
                />
              </div>
              <div className="text-center mb-4">
                <p className="font-display text-xl text-[#1C1917] mb-1">{tt.name}</p>
                <p className="text-sm text-[#57534E]">{tt.role}</p>
              </div>
              <blockquote className="font-display text-base md:text-[17px] leading-[1.6] text-[#57534E] text-center">
                "{tt.quote}"
              </blockquote>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
